var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTenor = function SvgTenor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16A7 7 0 1 0 9 1.998 7 7 0 0 0 9 16ZM8.125 5.062h1.75v3.575l2.15 2.151-1.237 1.237-2.663-2.662v-4.3Z",
    fill: "#305992"
  })));
};
export default SvgTenor;